import React from 'react';
import classNames from 'classnames';
import Ctlink from '../CtLink';
import './css/index.scss';

export default function CtActionPanel(props) {
  const { data, className } = props;
  const cls = classNames('tpm1-2-action-panel', className);
  return (
    <div className={cls}>
      <div className="tpm1-2-action-panel__inner">
        <main className="tpm1-2-action-panel__main">
          <div className="tpm1-2-action-panel__desc">{data.title}</div>
          <div className="tpm1-2-action-panel__btns">
            {data.links.map((item, index) => (
              <Ctlink
                text={item.text}
                to={item.to}
                type={item.type}
                key={`link-${index}`}
              />
            ))}
          </div>
        </main>
      </div>
    </div>
  );
}
